import type { CustomIconProps } from '../CustomIcon';

export function TimelessColours(props: CustomIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="4218.48 50.96 360 360" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M4398.47,53.96c-97.75,0-176.99,79.24-176.99,176.99s79.24,176.99,176.99,176.99,176.99-79.24,176.99-176.99-79.24-176.99-176.99-176.99M4398.47,59.37c94.61,0,171.58,76.97,171.58,171.58s-76.97,171.58-171.58,171.58-171.58-76.97-171.58-171.58,76.97-171.58,171.58-171.58"
      />
      <rect
        x="4236.12"
        y="198.02"
        width="221.13"
        height="65.87"
        rx="11.46"
        ry="11.46"
        transform="translate(4577.64 -4115.74) rotate(90)"
      />
      <path d="M4379.63,188.69l27.1-56.27c2.95-6.13,10.32-8.71,16.45-5.76l33.93,16.34c6.13,2.95,8.71,10.32,5.76,16.45l-83.73,173.87" />
      <path d="M4438.38,210.36l55.99-44.48c5.33-4.23,13.08-3.35,17.31,1.98l22.43,28.23c4.23,5.33,3.35,13.08-1.98,17.31l-151.48,120.35" />
      <path d="M4346.74,316.67c-6.38.02-11.58-5.13-11.6-11.52-.02-6.38,5.13-11.58,11.52-11.6,6.38-.02,11.58,5.13,11.6,11.52.02,6.38-5.13,11.58-11.52,11.6Z" />
      <line x1="4313.77" y1="227.26" x2="4379.63" y2="227.03" />
      <line x1="4380.18" y1="218.71" x2="4423.51" y2="238.8" />
      <line x1="4429.85" y1="229.2" x2="4462.62" y2="268.56" />
    </svg>
  );
}
